import { useState } from 'react';
import { FormFieldsContainer, WhiteCardContainer } from '../../components';
import { ProfileFormHeader } from './components/ProfileFormHeader';
import useAppointmentHistory from './hooks/useAppointmentHistory';
import SimpleDataTable from './components/simpleDataTable/SimpleDataTable';
import HistoryAppointmentDetails from './components/appointmentDetails/HistoryAppointmentDetails';
import PatientAppointmentHistory from './components/PatientAppointmentHistory';

export default function Appointments() {
    const [showHistoryView, setShowHistoryView] = useState(false);
    const [historyPatient, setHistoryPatient] = useState(null);
    const [historyDoctor, setHistoryDoctor] = useState(null);

    const {
        appointmentsTableInstance,
        isLoading,
        _closeAppointmentView,
        selectedAppointment,
        startDate,
        endDate,
        setStartDate,
        setEndDate,
        selectionMode,
        _handleSuccessfulEvent
    } = useAppointmentHistory();

    const handleViewHistory = (appointment) => {
        setHistoryPatient({
            userId: appointment.userId,
            userFullName: appointment.userFullName,
            userEmail: appointment.userEmail,
            userPhone: appointment.userPhone,
            birthDate: appointment.birthDate,
            appointmentId: appointment.apptID || appointment.id
        });
        setHistoryDoctor({
            doctorId: appointment.doctorId,
            doctorFullName: appointment.doctorFullName
        });
        setShowHistoryView(true);
    };

    const handleBackFromHistory = () => {
        setShowHistoryView(false);
        setHistoryPatient(null);
        setHistoryDoctor(null);
    };

    if (showHistoryView) {
        return (
            <PatientAppointmentHistory
                patient={historyPatient}
                doctor={historyDoctor}
                onBack={handleBackFromHistory}
            />
        );
    }

    return (
        <WhiteCardContainer>
            {JSON.stringify(selectedAppointment) === '{}' && (
                <FormFieldsContainer>
                    <ProfileFormHeader title={'Historial de citas'} />
                </FormFieldsContainer>
            )}
            {!isLoading && appointmentsTableInstance && JSON.stringify(selectedAppointment) === '{}' && (
                <SimpleDataTable
                    tableInstance={appointmentsTableInstance}
                    startDate={startDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    setStartDate={setStartDate}
                />
            )}

            {!isLoading && JSON.stringify(selectedAppointment) !== '{}' && (
                <HistoryAppointmentDetails
                    appointment={selectedAppointment}
                    onCancel={_closeAppointmentView}
                    selectionMode={selectionMode}
                    onSuccessfulSave={_handleSuccessfulEvent}
                    onViewHistory={handleViewHistory}
                />
            )}
        </WhiteCardContainer>
    );
}
